const cutPolicies = (policies = [], subString = 'Articles') => {
  // формирует новый массив при этом обрезает политики оставляя только
  // те что относятся к той фиче имя которой передано в subString и
  // вырезает  это имя из каждой  политики тем самым подготавливает
  // для сравнивания в функции policiesValid
  const newArr = []
  policies.forEach((item) => {
    if (item.includes(subString)) return newArr.push(item.replace(subString, ''))
    return item
  })
  return newArr
}

const searchPolicies = (policies = [], featureName = '') => {
  return policies.includes(featureName)
}

const policiesValid = (policies = [], val, type = 'publish') => {
  // когда вызываем функцию то передаем в неё массив политик, далее либо UniversalTagId либо имя политики, далее тип или publish или editing чтобы понимать какие полномочия мы проверем на редактирование или публикацию
  const universalsPublish = {
    1: 'PublishCompany',
    2: 'PublishTraining',
    3: 'PublishProduction',
    4: 'PublishEngineering',
    5: 'PublishDevelopment'
  }

  const universalsEditing = {
    1: 'EditingCompany',
    2: 'EditingTraining',
    3: 'EditingProduction',
    4: 'EditingEngineering',
    5: 'EditingDevelopment'
  }

  // если передана строка с именем политики то я ищу её в массиви политик
  if (typeof val === 'string') return policies.includes(val)

  // если передано число то это направление деятельности UniversalTagId
  // если publish то сопоставляю со списком на публикацию
  if (typeof val === 'number' && type === 'publish') {
    return policies.includes(universalsPublish[val])
  }

  // если editing то сопоставляю со списком на редактирование
  if (typeof val === 'number' && type === 'editing') {
    return policies.includes(universalsEditing[val])
  }
}

export { policiesValid, cutPolicies, searchPolicies }
